/* eslint-disable */

import React, { useCallback, useState, useEffect, useRef } from "react";
import {
    Box,
    Dialog,
    DialogContent,
    Grid,
    LinearProgress,
    Typography,
} from "@mui/material";
import {
    isArrayLength,
    niceBytes,
} from "../../../js/utils/genericMethods";
import Axios from "axios";
import { BasicButton } from "../../Widgets/Custom Inputs/Buttons";
import { t } from "react-i18nify";
import {
    deleteModel,
} from "../../../js/utils/backend";
import { DialogActionsForm } from "../../Widgets/CustomSurfaces";
import SharedSettings from "../../../common/sharedSettings.json";
import SkipIcon from '@mui/icons-material/NextPlanOutlined';
import ReplaceIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import { toastr } from "react-redux-toastr";
import { errorMessageDisplay } from "../../../js/utils/backend"
import { updateEntityTree } from "../../../js/redux/actions/userPref";
import { useDispatch } from "react-redux";
const chunkSize = 1048576 * SharedSettings.ChunkUploadSize; //Chunk upload size in megabytes (= 1048576 bytes)
const MAX_CHUNK_RETRIES = 2;
const CHUNK_RETRY_DELAY_MS = 400;
const CHUNK_REQUEST_TIMEOUT_MS = 120000;
const FINAL_CHUNK_REQUEST_TIMEOUT_MS = 900000;
export const maxFiles = 20;

export const isPhotoVideo = "PhotoVideo";
export const isDocuments = "Documents";

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const isTransientUploadError = error => {
    const status = error?.response?.status;
    return !status || status === 408 || status === 429 || status >= 500;
};

const uploadChunkWithRetry = async (requestFn, onRetry = null) => {
    let attempt = 0;
    while (attempt <= MAX_CHUNK_RETRIES) {
        try {
            return await requestFn();
        } catch (error) {
            if (!isTransientUploadError(error) || attempt === MAX_CHUNK_RETRIES) {
                throw error;
            }
            if (onRetry) {
                onRetry(attempt + 1, error);
            }
            await wait(CHUNK_RETRY_DELAY_MS * (attempt + 1));
            attempt += 1;
        }
    }
};

const getErrorDisplayText = error => {
    const responseData = error?.response?.data;

    if (typeof responseData === "string") {
        return responseData;
    }

    if (responseData && typeof responseData === "object") {
        if (typeof responseData.title === "string" && responseData.title.trim() !== "") {
            return responseData.title;
        }
        try {
            return JSON.stringify(responseData);
        } catch {
            return "Upload failed";
        }
    }

    const fallback = errorMessageDisplay(error);
    if (typeof fallback === "string" && fallback.trim() !== "") {
        return fallback;
    }

    return "Upload failed";
};

/** Previously, from : src/components/Views/DocumentsView.js /  */
const MediaChunksUploaderDialog = ({
    media,
    setMedia,
    token,
    setUploadedFile,
    forceGridRefresh,
    setForceGridRefresh,
    otEntityId,
    OTEntityTreeID,
    currentDocument,
    mediaIsUploaded,
    setSkipDocument,
    fileType,
    helpDocument = false,
    mediaCategory = "",
    mediaLanguage = "",
    isExternal = false,
    setOpenEditDialog = null,
    setMediaFileName = null,
    ...props
}) => {
    // MEMO WARNIGN CORN
    // eslint-disable-next-line
    const [showProgress, setShowProgress] = useState(true);

    const [counter, setCounter] = useState(1);
    const [beginingOfTheChunk, setBeginingOfTheChunk] = useState(0);
    const [endOfTheChunk, setEndOfTheChunk] = useState(chunkSize);
    const [progress, setProgress] = useState(0);
    const [chunkCount, setChunkCount] = useState(1);
    const [uploadedChunks, setUploadedChunks] = useState(0);
    const [fileSize, setFileSize] = useState(0);

    const [batchCompleted, setBatchCompleted] = useState([]);
    const [batchCancelled, setBatchCancelled] = useState([]);

    /* 'batchDuplicatedFiles' is used to trigger popup with overwriting the file of skip it, the idea is to merge the feature in the progress dialog and show every file that needs to be skipped or overwrited (near the filename)  */
    const [batchDuplicatedFiles, setBatchDuplicatedFiles] = useState([]);
    const [showDuplication, setShowDuplication] = useState(false)
    const [skipRefreshOnClose, setSkipRefreshOnClose] = useState(false)

    const [currentUpload, setCurrentUpload] = useState(null);
    const [currentUploadingFile, setCurrentUploadingFile] = useState(null);
    const currentUploadingFileRef = useRef(null);
    const isChunkUploadingRef = useRef(false);

    const [cancelUpload, setCancelUpload] = useState(false);
    const [openChunkDialog, setOpenChunkDialog] = useState(false);
    const [chunkRetry, setChunkRetry] = useState(null);

    /* 'batchPending' is about files remaining to be uploaded */
    const [batchPending, setBatchPending] = useState([]); // file list remaining to upload
    // (1) If we got something dropped via d&d or button dropzone  First upload of a media
    useEffect(() => {
        if (isArrayLength(media)) {
            setUploadedFile(undefined);
            const fileNamesArray = media?.map(({ name }) => name);
            const checking = async () => {
                try {
                    const responseCheckDuplicatedFiles = await Axios.post(
                        "media/CheckDuplicateFiles",
                        {
                            OTEntityTreeID: OTEntityTreeID,
                            FileNames: fileNamesArray,
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + token,
                            },
                        }
                    );
                    if (responseCheckDuplicatedFiles?.data?.Data?.length === 0) { // No duplicates, begin to upload
                        setBatchPending(media);
                    } else { // Some duplicated found, update array for further operation from user (Skip / Replace)
                        // We'll update batch pending files (whole set) and also update the duplicated files (just the concerned ones)
                        const _updatedBatchPending = media.filter(x => {
                            return !responseCheckDuplicatedFiles.data.Data.some(t => t.Key === x.path)
                        })
                        setBatchPending(_updatedBatchPending);
                        setBatchDuplicatedFiles(responseCheckDuplicatedFiles.data.Data); // INDEX FOR CHECK PURPOSE
                        setShowDuplication(true)
                    }
                    setOpenChunkDialog(true);
                } catch (error) {
                    toastr.error(errorMessageDisplay(error));
                }
            };
            checking();
        }
    }, [media, token, OTEntityTreeID]);



    // (2) We will continue to upload files THAT ARE NOT duplicates /
    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && isArrayLength(batchPending)) {
            const fileToUpload = batchPending.shift();
            proceedToUpload(fileToUpload);
        } 
        return () => (isSubscribed = false);
        // eslint-disable-next-line
    }, [batchPending]); // chunkSize

    // Use Effect that will proceed to overwriting wished files (replace all)
    const [batchFilesToOverwrite, setBatchFilesToOverwrite] = useState([])
    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && !isArrayLength(batchPending) && isArrayLength(batchFilesToOverwrite) && !currentUpload) { //&& !isArrayLength(batchPending)
            const fileToUpload = batchFilesToOverwrite.shift();
            batchDuplicatedFiles.filter(element => {
                if (element.Key === fileToUpload.name) {
                    if (!element.Value) {
                        return []
                    } else {
                        setMediaIDToReplace(element.Value)
                        return proceedToUpload(fileToUpload);
                    }
                } else {
                    return null
                }
            });
        } 
        return () => (isSubscribed = false);
        // eslint-disable-next-line
    }, [batchPending, batchFilesToOverwrite, batchDuplicatedFiles, currentUpload])







    /** Will set a new/next media to be uploaded:  */
    function proceedToUpload(file) {
        resetChunkProperties();
        setChunkUploadError(null);
        setInvalidZipFile(false);
        setChunkRetry(null);
        setUploadedChunks(0);
        setCurrentUploadingFile(null);
        currentUploadingFileRef.current = null;
        isChunkUploadingRef.current = false;
        setCurrentUpload(file);
        setFileSize(file.size);
        const totalCount =
            file.size % chunkSize === 0
                ? file.size / chunkSize
                : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will had to be uploaded to finish the file
        setChunkCount(totalCount);
    }

    // Controlling what happens between every uploaded chunks
    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            if (
                currentUpload &&
                fileSize > 0 &&
                counter <= chunkCount
            ) {
                // will upload next file as usually
                fileUpload();
            }
        }
        return () => (isSubscribed = false);
        // MEMO WARNING CORN
        // eslint-disable-next-line
    }, [
        currentUpload,
        cancelUpload,
        fileSize,
        counter,
        chunkCount,
    ]);

    /** Process that will upload a file, chunk by chunk */
    const fileUpload = () => {
        if (isChunkUploadingRef.current) {
            return;
        }
        if (counter <= chunkCount && currentUpload) {
            let chunk = currentUpload.slice(
                beginingOfTheChunk,
                endOfTheChunk
            );
            uploadChunk(chunk, counter);
        }
    };

    const resetChunkProperties = () => {
        setShowProgress(true);
        setProgress(0);
        setCounter(1);
        setBeginingOfTheChunk(0);
        setEndOfTheChunk(chunkSize);
    };

    const [mediaIDToReplace, setMediaIDToReplace] = useState(null);
    const [invalidZipFile, setInvalidZipFile] = useState(false);
    /** Process of chunking and uploading each.  */
    const uploadChunk = async (chunk, chunkNumber) => {
        if (isChunkUploadingRef.current) {
            return;
        }
        isChunkUploadingRef.current = true;
        let fileName = currentUpload.name;
        const _remaining = batchPending?.filter(
            element => JSON.stringify(element) !== JSON.stringify(currentUpload)
        );
        if (currentUpload) {
            try {
                let response;
                const currentUploadId = currentUploadingFileRef.current || currentUploadingFile;
                if(!helpDocument){
                    let url = `media/upload`;
                    const requestTimeout = chunkNumber === chunkCount
                        ? FINAL_CHUNK_REQUEST_TIMEOUT_MS
                        : CHUNK_REQUEST_TIMEOUT_MS;
                    response = await uploadChunkWithRetry(() =>
                        Axios.post(url, chunk, {
                            params: {
                                chunk: chunkNumber,
                                totalChunk: chunkCount,
                                fileName: fileName,
                                id: currentUploadId,
                                otEntityId: otEntityId,
                                replaceId: mediaIDToReplace,
                                totalSizeInBytes: fileSize,
                                photoVideo: fileType === isPhotoVideo,
                            },
                            headers: {
                                "Content-Type": "application/octet-stream",
                                "Content-Disposition": `attachment`,
                                Authorization: "Bearer " + token,
                            },
                            timeout: requestTimeout,
                        })
                    , (attempt) => {
                        setChunkRetry({ attempt, max: MAX_CHUNK_RETRIES, chunkNumber });
                    }
                    );
                }
                else{
                    let url = `media/uploadHelpDocument`;
                    const requestTimeout = chunkNumber === chunkCount
                        ? FINAL_CHUNK_REQUEST_TIMEOUT_MS
                        : CHUNK_REQUEST_TIMEOUT_MS;
                    response = await uploadChunkWithRetry(() =>
                        Axios.post(url, chunk, {
                            params: {
                                chunk: chunkNumber,
                                totalChunk: chunkCount,
                                fileName: fileName,
                                id: currentUploadId,
                                replaceId: mediaIDToReplace,
                                totalSizeInBytes: fileSize,
                                mediaCategory: mediaCategory,
                                mediaLanguage: mediaLanguage,
                                isExternal: isExternal
                            },
                            headers: {
                                "Content-Type": "application/octet-stream",
                                "Content-Disposition": `attachment`,
                                Authorization: "Bearer " + token,
                            },
                            timeout: requestTimeout,
                        })
                    , (attempt) => {
                        setChunkRetry({ attempt, max: MAX_CHUNK_RETRIES, chunkNumber });
                    }
                    );
                }
                const data = response.data;
                setCurrentUploadingFile(data);
                currentUploadingFileRef.current = data;
                if (data) {
                    setChunkRetry(null);
                    setUploadedChunks(chunkNumber);
                    setBeginingOfTheChunk(endOfTheChunk);
                    setEndOfTheChunk(endOfTheChunk + chunkSize);

                    // The file has finished to upload, we'll reset file-workflow
                    if (chunkNumber === chunkCount) {
                        if(helpDocument){
                            toastr.success(t("view.helpPage.contact.FileUploadedSuccessfully", {
                                fileName: `${fileName}`,
                            }));
                        }
                        const _uploaded = batchCompleted;
                        function containsObject(obj, list) {
                            return list.some(elem => elem === obj)
                        }

                        if (!containsObject(currentUpload, _uploaded)) {
                            _uploaded.push(currentUpload);
                        }
                        setBatchCompleted(_uploaded);
                        let fileWithDuplicateCheck = data;
                        if (mediaIDToReplace) {
                            setSkipDocument(fileWithDuplicateCheck);
                        }
                        else{
                            setSkipDocument(null);
                        }
                        setMediaIDToReplace(null);
                        setUploadedFile({ MediaID: fileWithDuplicateCheck, Filename: fileName });
                        setCurrentUploadingFile(null);
                        currentUploadingFileRef.current = null;
                        setProgress(100);
                        if (batchPending?.length === 0) {
                            setCurrentUpload(null);
                        }
                        resetChunkProperties();
                        setBatchPending(_remaining);
                    } else {
                        const percentage = (chunkNumber / chunkCount) * 100;
                        setProgress(percentage);
                        setCounter(chunkNumber + 1);
                    }
                } else {
                    console.error("Error Occurred:", data.errorMessage);
                }
            } catch (error) {
                /** Will be applied to the first failing file upload */
                setChunkRetry(null);
                setChunkUploadError({
                    fileName: fileName,
                    errorType: getErrorDisplayText(error),
                });
                if(error.response?.data==='(Invalid ZIP file)' || error.response?.data==='(Fichier ZIP invalide)')
                    setInvalidZipFile(true);
                console.error("error", error);
            } finally {
                isChunkUploadingRef.current = false;
            }
        }
    };

    const [chunkUploadError, setChunkUploadError] = useState();
    const displayProgress = progress > 0 && progress < 0.1 ? 0.1 : Math.min(100, progress);

    const showCancelUpload = currentUpload && !cancelUpload;
    const showCloseDialog = !isArrayLength(batchPending) && !currentUpload

    const dispatch = useDispatch();

    const onCloseDialog = useCallback(() => {
        setMedia([]);
        setOpenChunkDialog(false);
        setBatchCompleted([]);
        setBatchCancelled([]);
        setBatchPending([]);
        setBatchDuplicatedFiles([]);
        setBatchFilesToOverwrite([])
        setCurrentUpload(null);
         if (!skipRefreshOnClose || isArrayLength(batchCompleted)) {
            /* There's a slight latency between writing a file in database - POST -  and to display it immediately in the gird (GET), which can cause a rare situation (< 1%) where the file is missing in the refreshed paginated list. So, 1000ms is added to prevent this, meanwhile a better front/back solution is found. */
            setTimeout(() => {
                setForceGridRefresh(fgr => !fgr);
                dispatch(updateEntityTree());
            }, 1000);
        }
        setCurrentUploadingFile(null);
        currentUploadingFileRef.current = null;
        isChunkUploadingRef.current = false;
        setCancelUpload(false);
        setChunkUploadError(null);
        setChunkRetry(null);
        setUploadedChunks(0);
        setShowDuplication(false)
        // eslint-disable-next-line
        setSkipRefreshOnClose(false)
        }, [
            batchCompleted,
            dispatch,
            setForceGridRefresh,
            setMedia,
            skipRefreshOnClose,
        ]);

    
    return (
        <>
            <Dialog open={openChunkDialog}>
                <Box>
                    {isArrayLength(batchDuplicatedFiles) && showDuplication &&
                        <>
                        <Box sx={{m: 2}}>
                            <Typography>
                                {batchDuplicatedFiles?.length === 1 && `${batchDuplicatedFiles?.length} item was not uploaded, because the file with this name already exist`}
                                {batchDuplicatedFiles?.length > 1 && `${batchDuplicatedFiles?.length} items weren't uploaded, because the files with these names already exist :`}
                            </Typography>
                            {
                                batchDuplicatedFiles.map((item, index) => {
                                    return (
                                        <Typography variant="body2">
                                            {item.Key}
                                        </Typography>
                                    )
                                })
                            }
                        </Box>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <BasicButton fullWidth color="secondary"
                                    onClick={() => {
                                        // for every item in batchduplicatedfile [], remove from 'media'the file and update batch pending with the ned 'media' /// setBatchPending(updatedPendingBatch)
                                        // for every item in batchduplicatedfile [], add it also in the batchCancelled []
                                        const _updatedBatchCanceled = media.filter(x => {
                                            return batchDuplicatedFiles.some(t => t.Key === x.path)
                                        })
                                        setSkipRefreshOnClose(true)
                                        setBatchCancelled(_updatedBatchCanceled)
                                        setSkipRefreshOnClose(true)
                                        setBatchDuplicatedFiles(null)
                                        setShowDuplication(false)
                                    }}
                                >
                                    <SkipIcon sx={{ mr: 1 }} />
                                    {batchDuplicatedFiles?.length === 1 && "Skip"}
                                    {batchDuplicatedFiles?.length > 1 && "Skip all"}
                                </BasicButton>
                                <BasicButton fullWidth color="secondary"
                                    onClick={() => {
                                        const _updatedBatchToOverwrite = media.filter(x => {
                                            return batchDuplicatedFiles.some(t => t.Key === x.path)
                                        })
                                        // to overwrite exceptionnally the already existing files
                                        setBatchFilesToOverwrite(_updatedBatchToOverwrite) // we should got the valueID of each file and send it to be overwritten (as one of params, so the right file is replaced in DB)
                                        setShowDuplication(false)
                                        if(batchDuplicatedFiles?.length === 1){
                                            setMediaFileName(batchDuplicatedFiles[0].Key);
                                            setOpenEditDialog !== null && setOpenEditDialog(true);
                                        }
                                    }}
                                >
                                    <ReplaceIcon sx={{ mr: 1 }} />{" "}
                                    {batchDuplicatedFiles?.length === 1 && "Overwrite"}
                                    {batchDuplicatedFiles?.length > 1 && "Overwrite all"}
                                </BasicButton>
                            </Box>
                        </>
                    }
                </Box>
                <DialogContent>
                    {currentUpload && (
                        <Grid
                            container
                            sx={{
                                display: "flex",
                                alignItems: "baseline",
                                padding: "8px 0px",
                            }}
                        >
                            <Grid
                                item
                                xs={12}
                                sx={{ padding: "0px 16px 0px 0px" }}
                            >
                                <Typography variant="caption">
                                    {currentUpload.name} ~{" "}
                                    {niceBytes(currentUpload.size)}{" "}
                                    {chunkUploadError ? (
                                        <Box
                                            component="span"
                                            sx={{
                                                fontWeight: 700,
                                                color: "red",
                                            }}
                                        >
                                            {" "}
                                            : {chunkUploadError.errorType}{" "}
                                            Please try again
                                        </Box>
                                    ) : null}
                                    {chunkRetry ? (
                                        <Box
                                            component="span"
                                            sx={{
                                                fontWeight: 700,
                                                color: "#9a6b00",
                                            }}
                                        >
                                            {" "}
                                            : Upload timeout/network issue, retry {chunkRetry.attempt}/{chunkRetry.max} (chunk {chunkRetry.chunkNumber}/{chunkCount})
                                        </Box>
                                    ) : null}
                                    {!cancelUpload ? null : (
                                        <Box
                                            component="span"
                                            sx={{ fontWeight: 700 }}
                                        >
                                            {" "}
                                            : {t("dialog.Cancelled")}
                                        </Box>
                                    )}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{ display: "flex", alignItems: "center" }}
                            >
                                <Box sx={{ minWidth: 300, width: 600, mr: 1 }}>
                                    {!cancelUpload ? (
                                        !invalidZipFile && <LinearProgress variant="determinate" value={displayProgress} {...props} />
                                    ) : null}
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ padding: "0px 8px" }}
                                >
                                    {!cancelUpload
                                        ? (!invalidZipFile && `${displayProgress.toFixed(1)}% (${uploadedChunks}/${chunkCount})`)
                                        : null}{" "}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                    {batchPending?.map((item, index) => {
                        return (
                            <Grid
                                key={"Pending-"+item.name}
                                container
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {item.name} - ~ {niceBytes(item.size)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
                    {batchFilesToOverwrite?.map((item, index) => {
                        return (
                            <Grid
                                key={"Overwrite-"+item.name}
                                container
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {item.name} - ~ {niceBytes(item.size)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
                    {batchCompleted?.map((item, index) => {
                        let sameItem = item === currentUpload;
                        return (
                            <Grid
                                key={item.name}
                                container
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {item.name} - ~ {niceBytes(item.size)}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            minWidth: 300,
                                            width: 600,
                                            mr: 1,
                                        }}
                                    >
                                        <LinearProgress
                                            variant={
                                                sameItem ? "determinate" : null
                                            }
                                            value={100}
                                            {...props}
                                        />
                                    </Box>
                                    <Box sx={{ minWidth: 35 }}>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ padding: "0px 8px" }}
                                        >
                                            100%
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        );
                    })}
                    {batchCancelled?.map((item, index) => {
                        return (
                            <Grid
                                key={"Cancelled-" + item.name}
                                container
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "8px 0px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        {item.name} - ~ {niceBytes(item.size)}{" "}
                                        <Box
                                            component="span"
                                            sx={{ fontWeight: 700 }}
                                        >
                                            {" "}
                                            : {t("dialog.UploadSkipped")}
                                        </Box>
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    })}
                </DialogContent>
                <DialogActionsForm>
                    {showCancelUpload ? (
                        <BasicButton
                            type="button"
                            style={{
                                position: "relative",
                                margin: 4,
                            }}
                            onClick={() => {
                                setCancelUpload(true);
                                setUploadedFile(null);
                                let url = "media";
                                if (currentUploadingFile) {
                                    deleteModel(
                                        `${currentUploadingFile}/${otEntityId}`,
                                        token,
                                        url
                                    );
                                }
                                resetChunkProperties();
                                onCloseDialog();
                            }}
                        >
                            {invalidZipFile ? t("common.Close") : t("common.Cancel")}
                        </BasicButton>
                    ) : null}
                    {showCloseDialog && !showDuplication  ? (
                        <BasicButton
                            type="button"
                            style={{
                                position: "relative",
                                margin: 4,
                            }}
                            onClick={() => {
                                onCloseDialog();
                                //dispatch(updateEntityTree());
                            }}
                        >
                            {t("common.Close")}
                        </BasicButton>
                    ) : null}
                </DialogActionsForm>
            </Dialog>

        </>
    );
};

export default MediaChunksUploaderDialog;